import axios from "axios";
import React, {useEffect, useState, useRef, Fragment} from "react";
import {Link, NavLink, useParams, useNavigate, useLocation} from "react-router-dom"
import {render} from "react-dom";
import clientconfigwebapp, {
    empty_bk, convert_to_english_strhk, scrollTo_uphk, check_login_appbk, Token_get_appbk, redirectbh_typeb,scrollTo_bottom_enpage
} from '../../../clientconfigwebapp';
import {ToastContainer, toast} from 'react-toastify';

import Master_Front_Buyer from "../../Master_Front_Buyer";


import "../../../components/assets/css/profile.css"
import "../../../assets/cssnew/panel.css"
import "../../../assets/cssnew/TicketPage-messages.css"

import ReactFullPageLoadinghk from "../../../components/layaout/LoadingFullpagehk";




import Grid from '@mui/material/Grid';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import serialize from "form-serialize";

import {Back, Iconbk_edit1, Information} from '../../../assets/icones/icones';

function NewlineTextbk(props) {
    /// const text = textget;
    /// const newText = text.split('\n').map(str => <p>{str}</p>);
    ///const newText = text.split('\n').map(str => <p><br />{str}</p>);
    const text = props.text;
    return text.split('\n').map(str => <p>{str}</p>);
}


const Tickets_Messages_View = () => {
    const location = useLocation()
    const {tab_show_by_url} = useParams();


    const location_get_urlbk = useLocation();
    const redirect_navigate = useNavigate();
    const [loadinghkfullshow, Setloadinghkfullshow] = useState("false");

    /*  start profile */
    const [wallet_balance, setData_wallet_balance] = useState('0');
    const [first_name_profile, setData_first_name_profile] = useState('');
    const [last_name_profile, setData_last_name_profile] = useState('');
    const [profile_src, setData_profile_src] = useState('');
    const [type_user_panel, setData_type_user_panel] = useState('');
    /*  end profile */
    const [active_tab_curent, set_active_tab_curent] = useState("tab1");
    const [status_page, set_status_page] = useState("");

    const [Data_Full_Get, set_Data_Full_Get] = useState([]);


    /*  start code file_upload  */
    const [file, setFile] = React.useState();
    const [file_name_get, set_file_name] = React.useState('');
    const uploadRef = React.useRef();
    const statusRef = React.useRef();
    const loadTotalRef = React.useRef();
    const progressRef = React.useRef();
    const [attach_file_get, set_attach_file] = useState('');
    const [show_hide_pogressbar, setshow_hide_pogressbar] = useState('none');
    /*  endddd code file_upload  */

 const {id_ticket} = useParams();


    //   Tikets
    const [title_ticket_last_name, setData_title_ticket_last_name] = useState('');
    const [data_list, setData_data_list] = useState([]);
    const [data_full, setData_full_data_list] = useState([]);
    const [data_list_empty, setData_data_list_empty] = useState('');
    const [text_message, settext_message] = useState('');

    const [data_list_users, setData_list_users] = useState([]);





    const [showLinks, setShowLinks] = useState(true);

    const handleLinkClick = () => {
        setShowLinks(false);
    };

    const handleBackClick = () => {
        setShowLinks(true);
    };

    useEffect(() => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
            return false;
        }


        Load_api_page();

    }, [location_get_urlbk]);

    const Load_api_page = () => {
        scrollTo_uphk();
        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };

        Setloadinghkfullshow("true");

        const params = new URLSearchParams();
        params.append('id_ticket', String(id_ticket));


        axios.post(`${clientconfigwebapp.siteurl}api/v1/ticket-get-messages-pr`, params, config)
            .then((res) => {
                Setloadinghkfullshow("false");
                ///console.log(res.data);



                if (String(res.data.data).length > 0) {

                    if (String(res.data.data) == "login-show") {
                        redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                    }
                   // if (String(res.data.data) == "selectusertiket") { set_active_tab_curent('tab3')  }
                    if (String(res.data.status_page) == "selectusertiket") { set_status_page('selectusertiket')  }

                    if (!empty_bk(res.data.type_user)) {
                        setData_type_user_panel(res.data.type_user);
                    }

                    set_Data_Full_Get(res.data);

                    if (String(res.data.wallet_inventory).length > 0) {
                        setData_wallet_balance(res.data.wallet_inventory);
                    }

                    if (!empty_bk(res.data.first_name_profile)) {
                        setData_first_name_profile(res.data.first_name_profile);
                        localStorage.setItem('first_name_Get', res.data.first_name_profile);
                    }
                    if (!empty_bk(res.data.last_name_profile)) {
                        setData_last_name_profile(res.data.last_name_profile);
                        localStorage.setItem('last_name_Get', res.data.last_name_profile);
                    }


                    if (!empty_bk(res.data.profile_src)) {
                        setData_profile_src(res.data.profile_src);
                    }



                    if (String(res.data.data).length > 0) {
                        setData_full_data_list(res.data.data);
                    }



                        if (String(res.data.data.data_list_users).length > 0) {
                            setData_list_users(res.data.data.data_list_users);
                        } else {
                            setData_list_users([]);
                        }



                    if (String(res.data.data) != "selectusertiket" &&  String(res.data.data) != "selectusertiket") {
                        if (String(res.data.data.data_list).length > 0) {
                            setData_data_list(res.data.data.data_list);
                           /// scrollTo_bottom_enpage();
                        } else {
                            setData_data_list_empty("notfound")
                        }
                    }




                } else {
                    if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                        position: "top-center",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }

            }).catch((err) => {
            Setloadinghkfullshow("false");
            toast.error('خطا اتصال به سرور کد  435346', {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        });


    }


    const Handler_send_ticket_new = () => {

        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };

        Setloadinghkfullshow("true");


        //// let form_data = document.querySelector('#form_data_page');
        let form_data = document.querySelector('#form_data_page');
        //// form_data.append("fileeeeeeeeeeeeee","ddddddddddddd");

        ///attach_file_get
        if (form_data != null) {

            /// let data_serialize = serialize(form_data);
            let data_serialize = serialize(form_data);


            axios.post(`${clientconfigwebapp.siteurl}api/v1/ticket-new-message-response/`, data_serialize, config)
                .then((res) => {

                    Setloadinghkfullshow("false");


                    if (String(res.data.data).length > 0) {

                        if (String(res.data.data) == "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
                        }





                        if (String(res.data.status) == "success") {
                            toast.success(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });


                            window.location.reload();////ddddddddd


                        } else {

                            if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });

                        }


                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }).catch((err) => {
                Setloadinghkfullshow("false");
                toast.error('خطای اتصال به سرور کد 45346', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });


        }


    }



    const Handler_Chanche_text_message = (event) => {
        settext_message(String(convert_to_english_strhk(event.target.value)));
    }



    const UploadFile = () => {
        const file = uploadRef.current.files[0];
        console.log(file,"filefilefile");
        ///// setFile(URL.createObjectURL(file));
        setFile(URL.createObjectURL(file));
        set_file_name(file.name);
        var formData = new FormData();
        formData.append("fileattach", file);
        var xhr = new XMLHttpRequest();
        xhr.upload.addEventListener("progress", ProgressHandler, false);
        xhr.addEventListener("load", SuccessHandler, false);
        xhr.addEventListener("error", ErrorHandler, false);
        xhr.addEventListener("abort", AbortHandler, false);
        xhr.open("POST",String(clientconfigwebapp.host_dl_get) + "upload.php" );
        xhr.send(formData);


    };

    const ProgressHandler = (e) => {
        set_attach_file("");
        setshow_hide_pogressbar("flex");
        /// loadTotalRef.current.innerHTML = `uploaded ${e.loaded} bytes of ${e.total}`;
        var percent = (e.loaded / e.total) * 100;
        progressRef.current.value = Math.round(percent);
        ///statusRef.current.innerHTML = Math.round(percent) + "% uploaded...";
        statusRef.current.innerHTML = Math.round(percent) + "%";
    };

    const SuccessHandler = (e) => {
        set_attach_file("");
        var respons_get= e.target.response;

        ///  statusRef.current.innerHTML = e.target.responseText;
        progressRef.current.value = 0;
        statusRef.current.innerHTML = "0%";

        ///  setshow_hide_pogressbar("flex");

        console.log(respons_get,"respons_get");


        if(String(respons_get).length > 0 ){

            var respons_get_json=JSON.parse(respons_get);


            if (String(respons_get_json.data).length > 0) {


                if (String(respons_get_json.data)=="success" && !empty_bk(String(respons_get_json.file_name_get))){


                    set_attach_file(String( respons_get_json.file_name_get));
                    progressRef.current.value = 100;
                    statusRef.current.innerHTML = "100%";

                    if (String(respons_get_json.msgwebapp).length > 0){ toast.success(respons_get_json.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});  }




                }else{


                    if (String(respons_get_json.msgwebapp).length > 0){ toast.error(respons_get_json.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});  }

                }








            }else{

                if (String(respons_get_json.msgwebapp).length > 0){ toast.error(respons_get_json.msgwebapp, {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});  }

            }


        }else{

            toast.error("خطا در آپلود فایل کد خطا 654754", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});

        }











    };
    const ErrorHandler = () => {
        statusRef.current.innerHTML = "upload failed!!";
        setshow_hide_pogressbar("none");
        set_attach_file("");
        toast.error("خطا در ارتباط با سرور،اینترنت خود را بررسی کنید.کد خطا 567567", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
    };

    const AbortHandler = () => {
        statusRef.current.innerHTML = "upload aborted!!";
        setshow_hide_pogressbar("none");
        set_attach_file("");
        toast.error("خطا در ارتباط با سرور،اینترنت خود را بررسی کنید.کد خطا 789789", {position: "top-center", autoClose: 5000, hideProgressBar: false, closeOnClick: true, pauseOnHover: true, draggable: true, progress: undefined,});
    };


    return (<Fragment>

            <Master_Front_Buyer type_user_panel={type_user_panel} wallet_balance={wallet_balance}
                                first_name_profile={first_name_profile} last_name_profile={last_name_profile}
                                profile_src={profile_src}>
                <ReactFullPageLoadinghk loadinghk={loadinghkfullshow}/>
                <ToastContainer/>

                <div className={"box-content-panelbk"}>

             <div style={{"borderBottom":"2px solid rgb(229, 231, 235)","display":"flex","flexDirection":"row","alignItems":"center","alignContent":"center","justifyContent":"space-between"}}>
                 <span style={{"fontFamily":"'iran'","display":"block","fontSize":"21px","padding":"12px","fontWeight":"bold"}}>تیکت</span>


                 { !empty_bk(id_ticket) && String(id_ticket)!="undefined"   ? (

                     <Fragment> <NavLink to={"/panel/tickets"} reloadDocument={true}  className="back_button_list_mob"><Back /></NavLink></Fragment>
                 ) : (
                     <Fragment></Fragment>
                 )}

             </div>



                    <div className={`container-tikets-bk  ${status_page === 'selectusertiket' ? 'deactivesend' : ''}`}>

                        <form id={"form_data_page"} name={"form_data_page"} encType="multipart/form-data"
                              style={{width: "100%"}}>

                            <input type={"text"} value={id_ticket} name="id_ticket" style={{display: "none"}}/>
                            <input type={"text"} value={attach_file_get} name="attach_file_get"
                                   style={{display: "none"}}/>


                            <div className="list_users_tikets_mobile">
                                { empty_bk(id_ticket)  || String(id_ticket)=="undefined"  ? (
                                    data_list_users && data_list_users.length > 0 && (
                                        data_list_users.map((item_post, index) => {
                                            return (
                                                <NavLink
                                                    to={"/panel/tickets/" + String(item_post.id_tiket)}
                                                    reloadDocument={true}
                                                    className={`item_list_users_tikets ${item_post.active_current_chat === 'yes' ? 'active-chat-curent' : ''}`}
                                                    key={index}
                                                    onClick={handleLinkClick}
                                                >
                                <span className="name_user_list_tiket_users">
                                    {String(item_post.first_name) + " " + String(item_post.last_name)}
                                </span>
                                                    <span className="date_user_list_tiket_users">
                                    {String(item_post.date_fa)}
                                </span>
                                                </NavLink>
                                            );
                                        })
                                    )
                                ) : (
                                    <Fragment></Fragment>
                                )}
                            </div>

                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                display: String(active_tab_curent) === 'tab1' ? 'flex' : 'none'
                            }}>


                                <div className="flex lg:flex-row pt-3">


                                    <div className="w-full lg:w-1/4 ">

                                        <div className={"list_users_tikets"}>
                                            {
                                                data_list_users && data_list_users.length > 0 && (
                                                    data_list_users.map((item_post, index) => {
                                                        return (
                                                            <NavLink to={"/panel/tickets/" + String(item_post.id_tiket)}
                                                                     reloadDocument={true}
                                                                     className={`item_list_users_tikets ${item_post.active_current_chat === 'yes' ? 'active-chat-curent' : ''}`}
                                                                     key={index}>
                                                                <span
                                                                    className={"name_user_list_tiket_users"}> {String(item_post.first_name) + " " + String(item_post.last_name)}</span>
                                                                <span
                                                                    className={"date_user_list_tiket_users"}> {String(item_post.date_fa)}</span>
                                                            </NavLink>
                                                        );
                                                    })
                                                )
                                            }


                                        </div>


                                    </div>


                                    <div className="w-full lg:w-1/7 pb-[200px]  lg:pb-[350px]">


                                        <div className={'box-tickets-bk pr-[8px] '}>


                                            <div className="box-open-tickets-bk">


                                                {status_page === 'selectusertiket' && (
                                                    <div className="message_show_not_selectuser">

                                                        <svg width="62" height="62" viewBox="0 0 62 62" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M15.5007 5.16675C14.1304 5.16675 12.8162 5.71109 11.8473 6.68003C10.8783 7.64897 10.334 8.96313 10.334 10.3334V51.6668C10.334 53.037 10.8783 54.3512 11.8473 55.3201C12.8162 56.2891 14.1304 56.8334 15.5007 56.8334H46.5006C47.8709 56.8334 49.1851 56.2891 50.154 55.3201C51.123 54.3512 51.6673 53.037 51.6673 51.6668V20.6667L36.1673 5.16675H15.5007ZM15.5007 10.3334H33.584V23.2501H46.5006V51.6668H15.5007V10.3334ZM20.6673 31.0001V36.1667H41.334V31.0001H20.6673ZM20.6673 41.3334V46.5001H33.584V41.3334H20.6673Z"
                                                                fill="#9CA3AF"/>
                                                        </svg>

                                                        <div className={"title_box_tiket_notselect"}>
                                                            <span className={"title1_tiket_notselect"}>کاربری برای ارسال تیکت انتخاب نشده</span>

                                                            <span className={"title2_tiket_notselect"}>
                                                            برای شروع گفتگو با فروشندگان بازارانو، تیکت ارسال کنید.
                                                        </span>
                                                        </div>


                                                        <div className={"links_btn_tiket_notselect"}>
                                                            <NavLink className={"btn1_tiket_notselect"}
                                                                     reloadDocument={true} to={"/products"}>محصولات
                                                                فروشندگان</NavLink>
                                                            <NavLink className={"btn2_tiket_notselect"}
                                                                     reloadDocument={true} to={"/requirements"}>درخواست
                                                                های خریداران</NavLink>

                                                        </div>

                                                    </div>
                                                )}


                                                <div className="talk-ticbks">


                                                    {
                                                        data_list && data_list.length > 0 && data_list.map((item_post, index) => {
                                                            const isByMe = item_post.create_by === "by_me";
                                                            return (
                                                                <div key={index}
                                                                     className={`talk-ticbk ${isByMe ? "" : "message_by_admin"}`}>
                                                                    <svg className="avatar-ticbk" fill="#919191"
                                                                         width="187px" height="187px"
                                                                         viewBox="-10.88 -10.88 85.76 85.76"
                                                                         data-name="Layer 1" id="Layer_1"
                                                                         xmlns="http://www.w3.org/2000/svg"
                                                                         stroke="#919191">
                                                                        <g id="SVGRepo_bgCarrier" strokeWidth={0}
                                                                           transform="translate(2.879999999999999,2.879999999999999), scale(0.91)">
                                                                            <path
                                                                                transform="translate(-10.88, -10.88), scale(5.36)"
                                                                                fill="#ededed"
                                                                                d="M9.166.33a2.25 2.25 0 00-2.332 0l-5.25 3.182A2.25 2.25 0 00.5 5.436v5.128a2.25 2.25 0 001.084 1.924l5.25 3.182a2.25 2.25 0 002.332 0l5.25-3.182a2.25 2.25 0 001.084-1.924V5.436a2.25 2.25 0 00-1.084-1.924L9.166.33z"
                                                                                strokeWidth={0}/>
                                                                        </g>
                                                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round"
                                                                           strokeLinejoin="round" stroke="#CCCCCC"
                                                                           strokeWidth="0.128"/>
                                                                        <g id="SVGRepo_iconCarrier">
                                                                            <path
                                                                                d="M32,32.86a9.22,9.22,0,1,1,9.21-9.22A9.23,9.23,0,0,1,32,32.86Zm0-15.43a6.22,6.22,0,1,0,6.21,6.21A6.21,6.21,0,0,0,32,17.43Z"/>
                                                                            <path
                                                                                d="M32,56.64a24.68,24.68,0,0,1-15.22-5.27,1.52,1.52,0,0,1-.57-1.06c0-.16,0-.31,0-.47a15.8,15.8,0,1,1,31.6,0c0,.16,0,.31,0,.47a1.52,1.52,0,0,1-.57,1.06A24.68,24.68,0,0,1,32,56.64ZM19.21,49.45a21.62,21.62,0,0,0,25.58,0,12.8,12.8,0,0,0-25.58,0Zm27.08.74h0Z"/>
                                                                            <path
                                                                                d="M32,56.64a24.65,24.65,0,1,1,15.22-5.27A24.68,24.68,0,0,1,32,56.64Zm0-46.28A21.63,21.63,0,0,0,18.64,49a21.64,21.64,0,0,0,35-17A21.67,21.67,0,0,0,32,10.36Z"/>
                                                                        </g>
                                                                    </svg>
                                                                    <div className="text-ticbk">
                                                                        <NewlineTextbk text={item_post.text_message}/>
                                                                        {item_post.attach_file_get.length > 0 && (
                                                                            <a className="download-file-attach"
                                                                               href={item_post.attach_file_get}
                                                                               rel="nofollow" target="_blank">دانلود فایل
                                                                                ضمیمه</a>
                                                                        )}
                                                                    </div>
                                                                    <div className="time-tickbk">
                                                                        <span>{item_post.create_by_show} | </span> {item_post.date_fa}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })
                                                    }


                                                </div>


                                                <div className="send-box">



                                                    <textarea name="text_message" value={text_message}
                                                              onChange={Handler_Chanche_text_message} rows={1}
                                                              placeholder="پیام جدید خود را اینجا بنویسید"/>


                                                    <div className="act">


                                                        <div className={"btn-box-ticket"}>


                                                            {/*<label style={{*/}
                                                            {/*    "background": "rgba(102, 105, 109, 0.19)",*/}
                                                            {/*    "color": "rgb(78, 80, 83)",*/}
                                                            {/*    "padding": "8px",*/}
                                                            {/*    "borderRadius": "4px",*/}
                                                            {/*    "cursor": "pointer",*/}
                                                            {/*    "fontSize": "20px",*/}
                                                            {/*    "margin": "0px 2px",*/}
                                                            {/*    "border": "none",*/}
                                                            {/*    "width": "39px",*/}
                                                            {/*    "display": "inline-block",*/}
                                                            {/*    "textAlign": "center",*/}
                                                            {/*    "height": "39px"*/}
                                                            {/*}} htmlFor={"attach-file"}>*/}
                                                            {/*    <input type="file" id={"attach-file"} name="fileget"*/}
                                                            {/*           className={"input-file-btn"} ref={uploadRef}*/}
                                                            {/*           onChange={UploadFile}/>*/}
                                                            {/*    <AttachFileIcon/>*/}
                                                            {/*</label>*/}


                                                            <button onClick={Handler_send_ticket_new} type="button"
                                                                    style={{
                                                                        background: "rgba(10,93,241,0.1)",
                                                                        color: "#0A5DF1",
                                                                        padding: 8,
                                                                        borderRadius: 4,
                                                                        msBorderRadius: 4,
                                                                        WebkitBorderRadius: 4,
                                                                        OBorderRadius: 4,
                                                                        MozBorderRadius: 4,
                                                                        cursor: "pointer",
                                                                        fontSize: 20,
                                                                        margin: "0 3px",
                                                                        border: "none",
                                                                        height: 40,
                                                                        width: 40
                                                                    }}>
                                                                <svg xmlns="http://www.w3.org/2000/svg" width=""
                                                                     height="" viewBox="0 -0.5 26 25" fill="none"
                                                                     style={{
                                                                         width: 28,
                                                                         height: 33,
                                                                         position: "relative",
                                                                         top: "-5px",
                                                                         rotate: "181deg"
                                                                     }}>
                                                                    <path
                                                                        d="M19.1168 12.1484C19.474 12.3581 19.9336 12.2384 20.1432 11.8811C20.3528 11.5238 20.2331 11.0643 19.8758 10.8547L19.1168 12.1484ZM6.94331 4.13656L6.55624 4.77902L6.56378 4.78344L6.94331 4.13656ZM5.92408 4.1598L5.50816 3.5357L5.50816 3.5357L5.92408 4.1598ZM5.51031 5.09156L4.76841 5.20151C4.77575 5.25101 4.78802 5.29965 4.80505 5.34671L5.51031 5.09156ZM7.12405 11.7567C7.26496 12.1462 7.69495 12.3477 8.08446 12.2068C8.47397 12.0659 8.67549 11.6359 8.53458 11.2464L7.12405 11.7567ZM19.8758 12.1484C20.2331 11.9388 20.3528 11.4793 20.1432 11.122C19.9336 10.7648 19.474 10.6451 19.1168 10.8547L19.8758 12.1484ZM6.94331 18.8666L6.56375 18.2196L6.55627 18.2241L6.94331 18.8666ZM5.92408 18.8433L5.50815 19.4674H5.50815L5.92408 18.8433ZM5.51031 17.9116L4.80505 17.6564C4.78802 17.7035 4.77575 17.7521 4.76841 17.8016L5.51031 17.9116ZM8.53458 11.7567C8.67549 11.3672 8.47397 10.9372 8.08446 10.7963C7.69495 10.6554 7.26496 10.8569 7.12405 11.2464L8.53458 11.7567ZM19.4963 12.2516C19.9105 12.2516 20.2463 11.9158 20.2463 11.5016C20.2463 11.0873 19.9105 10.7516 19.4963 10.7516V12.2516ZM7.82931 10.7516C7.4151 10.7516 7.07931 11.0873 7.07931 11.5016C7.07931 11.9158 7.4151 12.2516 7.82931 12.2516V10.7516ZM19.8758 10.8547L7.32284 3.48968L6.56378 4.78344L19.1168 12.1484L19.8758 10.8547ZM7.33035 3.49414C6.76609 3.15419 6.05633 3.17038 5.50816 3.5357L6.34 4.78391C6.40506 4.74055 6.4893 4.73863 6.55627 4.77898L7.33035 3.49414ZM5.50816 3.5357C4.95998 3.90102 4.67184 4.54987 4.76841 5.20151L6.25221 4.98161C6.24075 4.90427 6.27494 4.82727 6.34 4.78391L5.50816 3.5357ZM4.80505 5.34671L7.12405 11.7567L8.53458 11.2464L6.21558 4.83641L4.80505 5.34671ZM19.1168 10.8547L6.56378 18.2197L7.32284 19.5134L19.8758 12.1484L19.1168 10.8547ZM6.55627 18.2241C6.4893 18.2645 6.40506 18.2626 6.34 18.2192L5.50815 19.4674C6.05633 19.8327 6.76609 19.8489 7.33035 19.509L6.55627 18.2241ZM6.34 18.2192C6.27494 18.1759 6.24075 18.0988 6.25221 18.0215L4.76841 17.8016C4.67184 18.4532 4.95998 19.1021 5.50815 19.4674L6.34 18.2192ZM6.21558 18.1667L8.53458 11.7567L7.12405 11.2464L4.80505 17.6564L6.21558 18.1667ZM19.4963 10.7516H7.82931V12.2516H19.4963V10.7516Z"
                                                                        fill="#000000"/>
                                                                </svg>
                                                            </button>


                                                        </div>


                                                    </div>


                                                    <div id="result_req_saved_pr"/>
                                                </div>


                                            </div>


                                        </div>


                                    </div>


                                </div>


                            </div>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                "paddingTop": "28px",
                                "paddingBottom": "25px",
                                display: String(active_tab_curent) === 'tab2' ? 'flex' : 'none'
                            }}>


                            </div>


                            <div style={{
                                width: "100%",
                                "flexDirection": "column",
                                "paddingTop": "28px",
                                "paddingBottom": "25px",
                                display: String(active_tab_curent) === 'tab3' ? 'flex' : 'none'
                            }}>
                                <div style={{
                                    "display": "block",
                                    "marginTop": "8px",
                                    "marginBottom": "8px",
                                    "backgroundColor": "#FFF3CD",
                                    "padding": "18px",
                                    "fontWeight": "bold",
                                    "fontFamily": "'iran'",
                                    "color": "#9B5800",
                                    "lineHeight": "1.6",
                                    "borderRadius": "8px",
                                    "fontSize": "13px",
                                    "textAlign": "center"
                                }}>.کاربر عزیز شما امکان تیکت، به اکانت خود را ندارید
                                </div>

                            </div>


                        </form>

                    </div>

                </div>


            </Master_Front_Buyer>
        </Fragment>
    );
}


export default Tickets_Messages_View;